import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding: 16px 32px 32px;

  ${({ theme }) => theme.media.mobile} {
    padding: 0;
  }
`;

export const ContentsWrapper = styled.div`
  height: 560px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};

  ${({ theme }) => theme.media.mobile} {
    height: auto;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
`;

export const Column = styled.div`
  width: 100%;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray800};
  text-align: center;

  &:nth-child(2) {
    flex: 0 0 130px;

    ${({ theme }) => theme.media.mobile} {
      flex: 0 0 90px;
    }
  }

  &:nth-child(3) {
    flex: 0 0 130px;

    ${({ theme }) => theme.media.mobile} {
      flex: 0 0 90px;
    }
  }
`;

export const ColumnHeader = styled(Column)`
  height: 45px;
  line-height: 45px;
  font-weight: bold;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
`;

export const ContentsList = styled.div`
  height: 510px;
  overflow-y: auto;

  ${({ theme }) => theme.media.mobile} {
    height: calc(100vh - 240px);
  }
`;

export const ContentItem = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
  height: 35px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray300};
  }
`;
